import Button from '../overrides/Button';
import MuiPaper from './MuiPaper';

export default {
  Button,
  MuiPaper
};
